var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leading-normal flex py-4 cursor-pointer items-baseline",class:{
    'text-black': _vm.active,
    'text-grey': !_vm.active,
  }},[_c('div',{staticClass:"mr-2 flex items-center"},[_c('div',{staticClass:"custom-radio rounded-full border h-custom flex items-center justify-center",class:{
        'border-orange-light': _vm.active,
        'border-grey-dark': !_vm.active,
      }},[(_vm.active)?_c('div',{staticClass:"bg-orange h-3 w-3 rounded-full"}):_vm._e()])]),_c('div',{staticClass:"flex items-center"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }